/* @ngInject */
function ProfilePictureController($rootScope, $scope, GravatarService) {
  const $ctrl = this;

  const onInit = () => {
    $ctrl.user = $scope.teamMember ? $scope.teamMember : $rootScope.user;
    $ctrl.gravatarPicture = GravatarService.getGravatarPicture(
      $ctrl.user.email,
      "https://app.quoters.io/img/quoters-avatar-base-user.png"
    );
    $ctrl.picture = $ctrl.user.profileImg
      ? $ctrl.user.profileImg.url
      : $ctrl.gravatarPicture;
  };

  onInit();

  $scope.$on("refreshUser", function () {
    onInit();
  });
}

function profilePicture() {
  return {
    restrict: "E",
    scope: {
      teamMember: "=?user",
    },
    replace: true,
    controllerAs: "$ctrl",
    controller: ProfilePictureController,
    template: `<img ng-src="{{$ctrl.picture}}">`,
  };
}

export default profilePicture;
